import { combineReducers } from "redux"

import { default as members } from "./members"

export default combineReducers({
  members
})
